// lists of fields which need converting between LC / GBP
const cap_ntie_components = [
  "ntlr_subtotal",
  "ntdc_subtotal",
  "tlr_subtotal",
  "tdc_subtotal",
  "ofa_subtotal",
];
const cap_GBP_conversion_values = ["tax_ebitda"];

const cap_LC_conversion_values = [
  "bfdadj_non_trading_loan_relationships_gbp",
  "bfdadj_non_trading_derivatives_gbp",
  "bfdadj_trading_loan_relationships_gbp",
  "bfdadj_trading_derivatives_gbp",
  "bfdadj_other_financing_gbp",
  "bfdadj_subtotal_gbp",
  "cpr_non_trading_loan_relationships_gbp",
  "cpr_non_trading_derivatives_gbp",
  "cpr_trading_loan_realtionships_gbp",
  "cpr_trading_derivatives_gbp",
  "cpr_other_financing_gbp",
  "cpr_total_gbp",
  "cfd_non_trading_loan_relationships_gbp",
  "cfd_non_trading_derivatives_gbp",
  "cfd_trading_loan_relationships_gbp",
  "cfd_trading_derivatives_gbp",
  "cfd_other_financing_gbp",
  "cpd_non_trading_loan_relationships_gbp",
  "cpd_non_trading_derivatives_gbp",
  "cpd_trading_loan_relationships_gbp",
  "cpd_trading_derivatives_gbp",
  "cpd_other_financing_gbp",
  "cpd_total_gbp",
];

// list of fields which need adjustment based on period inclusion
const cap_adjusted_values = [
  // NTLR Amounts (calculation_group: ['ntlr'])
  "nltr_total_per_source_sheet_for_period",
  "nltr_exclude_exchange_gains_losses",
  "nltr_exclude_impairment_gains_losses",
  "nltr_exclude_tax_interest_income_double_relief",
  "nltr_adjustment_amortised_cost_basis",
  "nltr_adjustment_qualifying_election",
  "nltr_exclude_defined_benefit_pension",
  "nltr_bank_expenses",
  "nltr_adjustment_gaap_transition",
  "nltr_adjustment_lease_finance_cost",
  "nltr_other_adjustments_1",
  "nltr_other_adjustments_2",
  "nltr_other_adjustments_3",
  "ntlr_subtotal",

  // NTDC Amounts (calculation_group: ['ntdc'])
  "ntdc_total_per_source_sheet_for_period",
  "ntdc_exclude_exchange_gains_losses",
  "ntdc_exclude_impairment_gains_losses",
  "ntdc_exclude_tax_interest_income_double_relief",
  "ntdc_exclude_ordinary_trade",
  "ntdc_exclude_derivatives_without_subject_matters_384(4)_s387(4)",
  "ntdc_adjustment_qualifying_election",
  "ntdc_adjustment_gaap_transition",
  "ntdc_adjustment_disregard_regulations",
  "ntdc_other_adjustments_1",
  "ntdc_other_adjustments_2",
  "ntdc_other_adjustments_3",
  "ntdc_subtotal",

  // TLR Amounts (calculation_group: ['tlr'])
  "tlr_total_per_source_sheet_for_period",
  "tlr_exclude_exchange_gains_losses",
  "tlr_exclude_impairment_gains_losses",
  "tlr_exclude_tax_interest_income_double_relief",
  "tlr_adjustment_amortised_cost_basis",
  "tlr_adjustment_qualifying_election",
  "tlr_exclude_defined_benefit_pension",
  "tlr_bank_expenses",
  "tlr_adjustment_gaap_transition",
  "tlr_adjustment_lease_finance_cost",
  "tlr_other_adjustments_1",
  "tlr_other_adjustments_2",
  "tlr_other_adjustments_3",
  "tlr_subtotal",

  // TDC Amounts (calculation_group: ['tdc'])
  "tdc_total_per_source_sheet_for_period",
  "tdc_exclude_exchange_gains_losses",
  "tdc_exclude_impairment_gains_losses",
  "tdc_exclude_tax_interest_income_double_relief",
  "tdc_exclude_ordinary_trade",
  "tdc_exclude_derivatives_without_subject_matters_384(4)_s387(4)",
  "tdc_adjustment_qualifying_election",
  "tdc_adjustment_gaap_transition",
  "tdc_adjustment_disregard_regulations",
  "tdc_other_adjustments_1",
  "tdc_other_adjustments_2",
  "tdc_other_adjustments_3",
  "tdc_subtotal",

  // OFA Amounts (calculation_group: ['ofa'])
  "ofa_total_per_source_sheet_for_period",
  "ofa_exclude_tax_interest_income_double_relief",
  "ofa_adjustment_qualifying_election",
  "ofa_adjustment_gaap_transition",
  "ofa_adjustment_finance_lease",
  "ofa_adjustment_debt_factoring",
  "ofa_adjustment_service_concession",
  "ofa_other_adjustments_1",
  "ofa_other_adjustments_2",
  "ofa_other_adjustments_3",
  "ofa_subtotal",

  // Tax-EBITDA Amounts (calculation_group: ['ofa'])
  "cte_condition_a",
  "cte_condition_b",
  "cte_restrictions_reactivations_included",
  "tebitda_adjustments",
  "cte_subtotal",
  "s407_tiopa_net_tax_interest_expense",
  "s407_tiopa_capital_allowance_charges",
  "s407_tiopa_relevant_intangible_debits_credits",
  "s407_tiopa_adjustment_intangible_debit_credits",
  "s407_tiopa_other_period_losses",
  "s407_tiopa_loan_relationship_deficts_other_periods",
  "s407_tiopa_expenses_management_other_periods",
  "s407_tiopa_group_relief",
  "s407_relief_rd_expenditure_credit",
  "s407_relief_rd_additional_relief",
  "s407_relief_trading_loss",
  "s407_relief_contaminated_land_relief",
  "s407_relief_creative_industries",
  "s407_relief_charitable_donation",
  "s407_relief_patent_box_profits",
  "s407_relief_dtr_adjustment_tax_rate_equal_uk", // TODO John (Confirm no issue with calculated metrics)
  "s407_relief_adjustment_qualifying_infrastructure",
  "s407_relief_adjustment_gaap_items",
  "s407_relief_finance_lease_depreciation",
  "s407_relief_reversal_of_lease_depreciation",
  "s407_relief_long_funding_lease_deduction",
  "s407_relief_finance_lease_rentals_receivable",
  "s407_relief_long_funding_lessee",
  "s407_relief_adjustment_misc_losses",
  "s407_relief_group_relief",
  "s407_relief_adjustment_disregarded_regulations",
  "s407_relief_other_adjustments_1",
  "s407_relief_other_adjustments_2",
  "s407_relief_other_adjustments_3",

  "s407_relief_dtr_adjustment_tax_rate_uk",

  "net_dtr_adjustment_gbp",
  "net_dtr_adjustment_lc",
];

export {
  cap_ntie_components,
  cap_LC_conversion_values,
  cap_GBP_conversion_values,
  cap_adjusted_values,
};
